export default () => `
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M26.0013 8.5H6.0013C5.54106 8.5 5.16797 8.8731 5.16797 9.33333V22.6667C5.16797 23.1269 5.54106 23.5 6.0013 23.5H26.0013C26.4615 23.5 26.8346 23.1269 26.8346 22.6667V9.33333C26.8346 8.8731 26.4615 8.5 26.0013 8.5Z"
        fill="transparent" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M20.168 20.1665H23.5013" fill="transparent" stroke="currentColor" stroke-linecap="round"
        stroke-linejoin="round" />
    <path d="M15.168 20.1665H16.8346" fill="transparent" stroke="currentColor" stroke-linecap="round"
        stroke-linejoin="round" />
    <path d="M5.16797 12.7554H26.8346" fill="transparent" stroke="currentColor" stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
`;
